import { CopyOutlined } from '@ant-design/icons'
import { Admin as AdminModel } from '@models/Admin'
import { getAdmins, selectAdmins, setAdminQuery } from '@store/AdminReducer'
import { selectLoggedUser } from '@store/UserReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { extractSortDataFromSorterResult } from '@utils/table/sorter'
import {
  Alert,
  App,
  Button,
  Checkbox,
  Flex,
  TableColumnsType,
  Typography,
} from 'antd'
import { TableProps } from 'antd/es/table'
import { useEffect } from 'react'

const { Text } = Typography

const AdminsPage = () => {
  const { message } = App.useApp()
  const dispatch = useAppDispatch()

  const items = useAppSelector(selectAdmins())
  const user = useAppSelector(selectLoggedUser)

  const { query, isLoading } = useAppSelector((state) => state.admin)
  const { isOpen } = useSBRM()

  const columns: TableColumnsType<AdminModel> = [
    {
      key: 'id',
      title: 'ID',
      render: (_, record) => record.id,
    },
    {
      key: 'azure-id',
      title: 'Azure ID',
      render: (_, record) => record.azureId,
    },
    {
      key: 'suser-admin',
      title: 'Est super admin',
      render: (_, record) => (
        <Checkbox checked={record.isSuperAdmin} disabled />
      ),
    },
  ]

  const handleTableChange: TableProps<AdminModel>['onChange'] = (
    pagination,
    filters,
    sorter
  ) => {
    const newQuery: TableParams = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setAdminQuery(newQuery))
    dispatch(getAdmins(newQuery))
  }

  useEffect(() => {
    dispatch(getAdmins(query))
  }, [dispatch, isOpen])

  return (
    <Flex vertical>
      <PageTitle title="Admins" level={5} />
      <Alert
        style={{ marginBottom: 12 }}
        title={
          <Text>
            Mon Admin Azure ID est :
            <Button
              type="text"
              icon={<CopyOutlined />}
              iconPlacement="end"
              onClick={() => {
                navigator.clipboard.writeText(user?.id ?? '')
                message.success('ID copié dans le presse-papier')
              }}
            >
              <Text strong>{user?.id}</Text>
            </Button>
          </Text>
        }
      />
      <SBTable
        scroll={{ x: 600 }}
        columns={columns}
        dataSource={items}
        pagination={query.pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </Flex>
  )
}

export default AdminsPage
